import Accordion from 'accordion-js';
import {getElements} from "./utils/getElement";

const initAccordions = () => {
    const accordionsGroup = getElements('.js-accordions')
    if (accordionsGroup) {
        accordionsGroup.map(accordions => {
            new Accordion(accordions, {
                duration: 300,
            });
        })
    }
}

export {initAccordions}
